import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, InteractionType, LocalService, PageKey, Status, Wrappers15 } from 'src/service/local.service';
import { SupplierService } from 'src/service/supplier.service';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrl: './suppliers.component.scss'
})
export class SuppliersComponent {
  lstSectionConfigKeys: string[] = ["common", "table", "supplier"];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  source: Wrappers15; isOpenSupplier = false; selectedSupplierId: string = '';
  isShowInActive: boolean = false;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private supplierService: SupplierService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.Suppliers, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {

  }

  onLoad() {
    this.supplierService.getSuppliers(this.businessId, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
      this.source = result;
    });
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedSupplierId = key;
        this.isOpenSupplier = true;
      } break;
    }
  }

  onActiveInactiveStatus(key: string) {
    this.supplierService.activeInactiveStatus(key, ActiveInactiveFor.Supplier).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }
}
